import React from 'react'
import { FaGit, FaTwitter, FaLinkedinIn, FaReact, FaJs,FaHtml5,FaCss3 } from "react-icons/fa";
import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";
const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
           <a href='https://github.com/Soubhagya118'><span className="bannerIcon">
              <FaGit />
            </span></a> 
            <a href='https://twitter.com/soubhagyaasama1'>  <span className="bannerIcon">
              <FaTwitter />
            </span></a>
          
            <a href='https://www.linkedin.com/in/soubhagya-samal-4496171ba/'> <span className="bannerIcon">
              <FaLinkedinIn />
            </span></a>
           
          </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <FaJs />
            </span>
            <span className="bannerIcon">
              <FaHtml5 />
            </span>
            {/* <span className="bannerIcon">
              <SiTailwindcss />
            </span> */}
            <span className="bannerIcon">
              <FaCss3 />
            </span>
          </div>
        </div>
      </div>
  )
}

export default Media